/** @module csi/widget/_DateTimeMixin */
define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"dojo/aspect",
	"dojo/keys",
	"csi/_base/underscore",
	"csi/types"
], function(declare,lang,aspect,keys,_,types) {

	return declare(null, {
		// Boolean: indicates if widget opened with click rather than by keyboard
		clicked: false,

		// Object: handle to listen for drop down click events
		//_dropDownHandle: null,

		// String: function to listen for change by mouse click
		//_popupClickEvent: null,

		// Number[]: array of keys to trap when drop-down is not open
		//_textKeys: [],

		/**
		 * If passed a number, then convert to Date; if passed a date, then just return it
		 * @param {Date|number} value
		 * @return {Date}
		 */
		normalizeValue: function(value) {
			if (!value) {
				return null;
			}

			const valueNumber = parseInt(value);
			if (isNaN(valueNumber)) {
				return value;
			}

			return types.getTimeDate(valueNumber);
		},

		onInput: function(/*Event*/e) {
			// summary: need to provide extension point to differentiate between
			// keyboard events when drop-down opened vs. closed; by default do not differentiate (which works for DateTextBox)
			this.onTextBoxInput(e);
		},

		onClicked: function(/*Event*/e) {
			// summary: extension point for value being changed by mouse click as opposed to keyboard
		},

		onTextBoxEscape: function(/*Event*/e) {
			// summary: extension point for when escape key is pressed
		},

		onTextBoxInput: function(/*Event*/e) {
			// summary: extension point for input entered on text box
		},

		openDropDown: function(/*Function*/callback) {
			// summary: expose event when value changed by mouse click
			if (this._dropDownHandle) {
				this._dropDownHandle.remove();
			}

			this.inherited(arguments);

			if (this._popupClickEvent && this.clicked) {
				this._dropDownHandle = aspect.after(this.dropDown, this._popupClickEvent, lang.hitch(this, this._onClicked), true);
			}
		},

		_onClicked: function(/*Event*/e) {
			// summary: determine if event was really triggered by mouse (or emitted as click event even though it came from keyboard)
			if (!e._origType) {
				this.onClicked(e);
			}
		},

		_onKey: function(/*Event*/e) {
			// summary: don't open the drop down when pressing one of the following keys so as not to
			// interfere with table navigation or other textbox edits
			var	bOpen = this._opened;

			if (!bOpen && this._textKeys && (_.indexOf(this._textKeys, e.keyCode) >= 0)) {
				return;
			}

			this.inherited(arguments);

			// if drop down was open but is now closed due to the escape key, and the widget was created by a click event
			// then pass event along as if it happened on the text box rather than the drop-down
			if (!this._opened && e.keyCode == keys.ESCAPE) {
				if (bOpen && this.clicked) {
					this.onTextBoxInput(e);
				} else if (!bOpen) {
					this.onTextBoxEscape(e);
				}
			}
		}
	});
});
